var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "scale(1)",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    className: "show_show__wrapper__graphic__5Waiy ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "React") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D1D3D4;}\r\n\t.st1{fill:#474747;}\r\n\t.st2{fill:#db3236;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Server_and_Cables"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.4,401.9c-0.2,0-0.4-0.1-0.5-0.2c-0.3-0.3-0.3-0.7,0-1c4.4-4.4,5.2-65.4,5.9-119.3 c0.6-42.9,1.1-83.5,3.4-93.4c5.2-22.6,29.3-24.2,29.6-24.3c0.4,0,0.7,0.3,0.7,0.7c0,0,0,0,0,0c0,0.4-0.3,0.7-0.7,0.7c0,0,0,0,0,0 c-0.2,0-23.3,1.6-28.3,23.2c-2.2,9.7-2.8,50.2-3.3,93.1c-0.9,67.6-1.9,115.8-6.3,120.3C102.8,401.8,102.6,401.8,102.4,401.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.9,397.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.3,0.2-0.6,0.5-0.7c11.2-3.7,9-121,7.7-191c-0.7-36-1.2-64.5-0.1-70.8 c1.4-7.9,3.7-12.4,6.9-13.4c3-0.9,5.5,1.7,5.6,1.8c0.3,0.3,0.3,0.7,0,1s-0.7,0.3-1,0c0,0-2-2.1-4.2-1.4c-1.8,0.5-4.3,3.1-5.9,12.3 c-1.1,6.2-0.6,34.6,0.1,70.6c1.9,99.3,2.6,188.6-8.6,192.4C116,397.3,116,397.3,115.9,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.7,397.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.1,0-0.2,0.1-0.4c10-15.6,22.9-234.8,22.2-254.5 c-0.2-6,1.1-9.9,3.9-11.6c3.8-2.3,8.6,0.2,8.9,0.4c0.3,0.2,0.4,0.6,0.2,1c-0.2,0.3-0.6,0.4-0.9,0.3c0,0-4.4-2.3-7.5-0.4 c-2.3,1.4-3.4,4.9-3.2,10.4c0.3,8.5-2.6,67.2-7.1,127.9c-3.9,53.2-9.7,118.6-15.3,127.4C107.2,397.2,107,397.3,106.7,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.9,397.3c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.6-0.5-0.5-0.8c0,0,0,0,0,0c2.9-11,4-26.1,4-55.7 c0-7.4,0-182.2,3.3-194.8c3.1-12.1,21.6-8.8,22.4-8.6c0.4,0.1,0.6,0.4,0.6,0.8s-0.4,0.6-0.8,0.6l0,0c-0.2,0-18-3.2-20.8,7.6 c-3.2,12.5-3.3,192.6-3.3,194.5c0,29.7-1.1,44.9-4,56.1C112.5,397.1,112.2,397.3,111.9,397.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.4,398.4c-3,0-6-0.4-8.9-1.1c-0.4-0.1-0.6-0.4-0.5-0.8c0.1-0.4,0.4-0.6,0.8-0.5c0,0,0.1,0,0.1,0 c0.2,0,16.3,4.3,22.2-4.8c3.4-5.4,3.4-36.4,3.4-63.8c0-21.1,0-41,1.5-48.5c1-5.4,3.5-9.2,7.1-11.3c6.2-3.6,13.6-1.2,14-1.1 c0.4,0.1,0.6,0.5,0.4,0.9c-0.1,0.4-0.5,0.6-0.9,0.4l0,0c-0.1,0-7.2-2.3-12.8,1c-3.3,1.9-5.5,5.4-6.5,10.4 c-1.5,7.4-1.4,27.2-1.4,48.3c0,28.9,0,58.9-3.6,64.6C105.8,397.1,99.7,398.4,94.4,398.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 137.7,
    y: 109.2,
    width: 98.5,
    height: 289.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.2,399.4h-98.5c-0.4,0-0.7-0.3-0.7-0.7l0,0V109.3c0-0.4,0.3-0.7,0.7-0.7h98.5c0.4,0,0.7,0.3,0.7,0.7v289.5 C236.9,399.1,236.6,399.4,236.2,399.4z M138.4,398h97.1V110h-97.1L138.4,398z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 120.9,
    width: 8.6,
    height: 31.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,152.9h-8.6c-0.4,0-0.7-0.3-0.7-0.7v-31.3c0-0.4,0.3-0.7,0.7-0.7h8.6c0.4,0,0.7,0.3,0.7,0.7v31.3 C241.2,152.6,240.9,152.9,240.5,152.9C240.5,152.9,240.5,152.9,240.5,152.9z M232.6,151.5h7.2v-29.9h-7.2V151.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 157.5,
    width: 8.6,
    height: 31.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,189.6h-8.6c-0.4,0-0.7-0.3-0.7-0.7v-31.3c0-0.4,0.3-0.7,0.7-0.7h8.6c0.4,0,0.7,0.3,0.7,0.7v31.3 C241.2,189.2,240.9,189.6,240.5,189.6z M232.6,188.2h7.2v-29.9h-7.2V188.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 194.2,
    width: 8.6,
    height: 31.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,226.2h-8.6c-0.4,0-0.7-0.3-0.7-0.7v-31.3c0-0.4,0.3-0.7,0.7-0.7h8.6c0.4,0,0.7,0.3,0.7,0.7v31.3 C241.2,225.9,240.9,226.2,240.5,226.2C240.5,226.2,240.5,226.2,240.5,226.2z M232.6,224.8h7.2v-29.9h-7.2V224.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 230.8,
    width: 8.6,
    height: 31.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,262.8h-8.6c-0.4,0-0.7-0.3-0.7-0.7l0,0v-31.3c0-0.4,0.3-0.7,0.7-0.7h8.6c0.4,0,0.7,0.3,0.7,0.7v31.3 C241.2,262.5,240.9,262.8,240.5,262.8z M232.6,261.4h7.2v-29.9h-7.2V261.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 272.1,
    width: 8.6,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,286.5h-8.6c-0.4,0-0.7-0.3-0.7-0.7l0,0v-13.8c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h8.6 c0.4,0,0.7,0.3,0.7,0.7v13.8C241.2,286.2,240.9,286.5,240.5,286.5C240.5,286.5,240.5,286.5,240.5,286.5z M232.6,285.1h7.2v-12.4 h-7.2V285.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 291.4,
    width: 8.6,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,305.8h-8.6c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-13.8c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h8.6 c0.4,0,0.7,0.3,0.7,0.7l0,0v13.8C241.2,305.5,240.9,305.8,240.5,305.8z M232.6,304.4h7.2v-12.3h-7.2V304.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 310.7,
    width: 8.6,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,325.1h-8.6c-0.4,0-0.7-0.3-0.7-0.7l0,0v-13.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h8.6 c0.4,0,0.7,0.3,0.7,0.7v13.8C241.2,324.8,240.9,325.1,240.5,325.1z M232.6,323.7h7.2v-12.4h-7.2V323.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 330,
    width: 8.6,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,344.4h-8.6c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0V330c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h8.6 c0.4,0,0.7,0.3,0.7,0.7l0,0v13.8C241.2,344.1,240.9,344.4,240.5,344.4z M232.6,343h7.2v-12.3h-7.2V343z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 349.3,
    width: 8.6,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,363.7h-8.6c-0.4,0-0.7-0.3-0.7-0.7l0,0v-13.8c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h8.6 c0.4,0,0.7,0.3,0.7,0.7V363C241.2,363.4,240.9,363.7,240.5,363.7C240.5,363.7,240.5,363.7,240.5,363.7z M232.6,362.3h7.2V350h-7.2 V362.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 231.9,
    y: 368.6,
    width: 8.6,
    height: 13.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,383h-8.6c-0.4,0-0.7-0.3-0.7-0.7c0,0,0,0,0,0v-13.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h8.6 c0.4,0,0.7,0.3,0.7,0.7l0,0v13.8C241.2,382.7,240.9,383,240.5,383z M232.6,381.6h7.2v-12.3h-7.2V381.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 132.2,
    y: 113.7,
    width: 14.1,
    height: 279.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.3,394.3h-14.1c-0.4,0-0.7-0.3-0.7-0.7l0,0V113.7c0-0.4,0.3-0.7,0.7-0.7h14.1c0.4,0,0.7,0.3,0.7,0.7v279.9 C147,394,146.7,394.3,146.3,394.3z M132.9,392.9h12.7V114.4h-12.7V392.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.6,185c0,0,19.7-38.5,35-47.9l8.1,49.2L283.6,185z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.4,239.1l10.4,140.7c0,0-3,3.8-13,3.8s-13.4-5-13.4-5l-21.7-102.3c0,0-12,85.3-13.3,100.4 c0,0-15.2,4.8-23.6-1.9c0,0,3.1-79.6,3.3-105.1c0.3-17,1.4-33.9,3.4-50.8H379L382.4,239.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M388.1,379.3c0,0,0.4,8.4,2.9,14.7s2.3,9.7,0,11.8s-14.3,2.3-19.9-1.5s1.4-13.8,1.5-17.6 c-0.1-3.3-0.4-6.6-0.8-9.9L388.1,379.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.7,376.8c0,0,2.7,10.1,1.9,16.8s-1.9,5.9-1.9,5.9h-13.9l-0.8-2.5c-4.2,1.8-8.7,3-13.2,3.8 c-6.3,0.8-20.1,0-19.7-2.7s15.7-7.6,19.7-12.4s13.4-17.2,13.4-17.2L328.7,376.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.6,137.1c0,0,42.2-7.5,56.8,2c12.9,25.7,12.9,106.8,12.9,106.8l-79.3,1.6 C309,247.4,311.1,143.8,318.6,137.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "356.5,144.2 345.7,176.3 335,149.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.7,177c-0.3,0-0.5-0.2-0.6-0.4l-10.7-26.8c-0.1-0.2-0.1-0.4,0-0.6c0.1-0.2,0.3-0.3,0.5-0.4l21.5-5.3 c0.2-0.1,0.5,0,0.7,0.2c0.2,0.2,0.2,0.5,0.1,0.7l-10.8,32.1C346.2,176.8,346,177,345.7,177L345.7,177z M335.9,150l9.7,24.3 l9.8-29.1L335.9,150z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M362.5,189.4c0,0-2.6-1.5-3.4-1.5s-4.6,1.6-7.4-1.1c0,0,1.3,1.4-1.3,1.3s-4.6,0.4-6-1.8c0,0-2.1,0.4-2.9-1.3 c0,0-2.8,0.3-3.1-2.1s2.2-6.7,2.2-6.7s-6.8,2-9.7,2.7s-3.2-1.7-2.1-3.1s10.3-4.3,14-4.7s17.5,4,20.6,5.7 C363.2,176.8,363.8,185.3,362.5,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.5,190.1c-0.1,0-0.3,0-0.4-0.1c-1-0.6-2-1.1-3.1-1.4l-0.6,0.1c-1.3,0.3-3.8,0.8-6.1-0.5 c-0.6,0.5-1.3,0.7-2,0.6h-1.2c-1.9,0-3.8,0-5.1-1.7c-1.2,0.1-2.3-0.4-3-1.3c-1.7,0.1-3.1-1.1-3.4-2.7c-0.2-1.7,0.8-4.1,1.5-5.6 c-2.2,0.6-6.1,1.8-8.1,2.3s-2.9-0.4-3.2-0.9c-0.6-1.1-0.4-2.4,0.4-3.4c1.4-1.7,11.1-4.6,14.4-5c4-0.5,18,4.1,21,5.7 c0.2,0.1,0.4,0.3,0.4,0.6c0,0.4,0.6,8.7-0.7,12.9c-0.1,0.2-0.2,0.4-0.4,0.5C362.6,190.1,362.6,190.1,362.5,190.1z M359,187.2 c1.1,0.2,2.1,0.6,3,1.1c0.8-3.6,0.6-9.5,0.5-11.1c-3.7-1.8-16.6-5.8-19.8-5.4c-4,0.5-12.7,3.5-13.5,4.5c-0.4,0.5-0.5,1.1-0.3,1.7 c0.3,0.5,1.2,0.4,1.7,0.2c2.9-0.7,9.6-2.7,9.7-2.7c0.4-0.1,0.8,0.1,0.9,0.5c0.1,0.2,0,0.4-0.1,0.6c-0.7,1.2-2.3,4.6-2.1,6.3 c0.2,1.6,2.1,1.5,2.3,1.4c0.3,0,0.6,0.1,0.7,0.4c0.5,1.2,2.1,0.9,2.1,0.9c0.3-0.1,0.6,0.1,0.8,0.3c0.9,1.4,2.1,1.5,4.2,1.4h1.2 c0.3,0,0.5,0,0.8,0l0,0c-0.3-0.3-0.3-0.7,0-1c0.3-0.3,0.7-0.3,1,0c2,1.9,4.6,1.3,6,1C358.4,187.3,358.7,187.2,359,187.2L359,187.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351,188.8c-0.4,0-0.7-0.3-0.8-0.7c0-0.4,0.3-0.7,0.7-0.8l0,0c0.1,0,0.7-0.2,0.7-0.7c-0.6-0.1-1.2-0.1-1.7,0 c-0.3,0.1-0.6-0.1-0.8-0.4c-0.1-0.3-0.1-0.6,0.1-0.9l2.6-2.4c0.3-0.3,0.7-0.3,1,0c0.3,0.3,0.3,0.7,0,1l0,0l-1.2,1.1 c0.3,0.1,0.7,0.2,0.9,0.4c0.3,0.3,0.5,0.7,0.5,1.1c0,1.1-0.8,2-1.9,2.1L351,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M344.3,187.1h-0.1c-0.4-0.1-0.6-0.5-0.6-0.9c0.3-1.7,1-3.3,2-4.7c0.2-0.3,0.7-0.4,1-0.1c0.3,0.2,0.4,0.7,0.1,1 c-0.8,1.3-1.4,2.7-1.7,4.1C345,186.8,344.7,187.1,344.3,187.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.4,185.8c-0.3,0-0.6-0.2-0.7-0.6c-0.3-2.3,0.6-4.5,2.4-6c0.3-0.3,0.8-0.3,1,0s0.3,0.8,0,1l0,0 c-1.4,1.1-2.1,2.9-1.9,4.6c0.1,0.4-0.2,0.8-0.6,0.8c0,0,0,0,0,0L341.4,185.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.1,211.7c0,0-31.2-2.7-32.1-12.1s14.3-20.9,16.9-21.4s19.9,10.3,19.9,10.3L308.1,211.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M305.8,195.4c0,0-4.8,14.7,2.3,16.2s10.3-13.6,7.7-15.8S305.8,195.4,305.8,195.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 339.7,
    y: 189.4,
    width: 15.6,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.3,194.6h-15.6c-0.4,0-0.7-0.3-0.7-0.7v-4.4c0-0.4,0.3-0.7,0.7-0.7h15.6c0.4,0,0.7,0.3,0.7,0.7l0,0v4.4 C356,194.2,355.7,194.6,355.3,194.6L355.3,194.6z M340.4,193.1h14.2v-3h-14.2L340.4,193.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 281,
    y: 189.4,
    width: 58.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,194.6H281c-0.4,0-0.7-0.3-0.7-0.7l0,0v-4.4c0-0.4,0.3-0.7,0.7-0.7l0,0h58.7c0.4,0,0.7,0.3,0.7,0.7l0,0 v4.4C340.4,194.2,340.1,194.5,339.7,194.6z M281.7,193.1H339v-3h-57.2L281.7,193.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "339.7,189.4 317,155.7 256.9,155.7 281,189.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.7,190.1H281c-0.2,0-0.4-0.1-0.6-0.3l-24.1-33.7c-0.2-0.2-0.2-0.5,0-0.8c0.1-0.2,0.4-0.4,0.6-0.4H317 c0.2,0,0.5,0.1,0.6,0.3l22.7,33.7c0.1,0.2,0.1,0.5,0,0.7C340.2,190,340,190.1,339.7,190.1z M281.4,188.7h57l-21.8-32.2h-58.4 L281.4,188.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.6,202.3c0,0-0.1-5.3,1.1-6.9s12.6-9.3,13.7-7.7s-2.9,5.7-2.9,5.7s26.8-1.7,26.3,0.1s-2,2.6-4,3.1 s-11.2,2.3-13.5,3.4s-10.5,4.4-14.5,4C308.9,203.9,306.7,203.3,304.6,202.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.9,204.9c-0.3,0-0.6,0-0.9,0c-2.4-0.2-4.6-0.9-6.7-2c-0.2-0.1-0.4-0.4-0.4-0.6c0-0.6-0.1-5.6,1.3-7.4 c1.2-1.4,10.8-8.2,13.8-8.2h0c0.4,0,0.8,0.2,1.1,0.5c1,1.4-0.5,3.8-1.8,5.3c9.6-0.6,23.9-1.2,25.1,0.3c0.2,0.2,0.3,0.5,0.2,0.8 c-0.5,2.4-2.6,3.1-4.5,3.7c-0.6,0.2-2,0.5-3.6,0.8c-3.3,0.7-8.2,1.8-9.7,2.6S316.6,204.9,311.9,204.9z M305.4,201.9 c1.8,0.8,3.8,1.4,5.8,1.6c3.6,0.4,11.4-2.6,14.1-3.9c1.7-0.8,6.3-1.9,10.1-2.7c1.6-0.3,2.9-0.6,3.5-0.8c1.8-0.5,2.9-1,3.4-2.2 c-2.3-0.7-14.4-0.4-25.5,0.4c-0.3,0-0.6-0.1-0.7-0.4c-0.1-0.3-0.1-0.6,0.1-0.8c1.6-1.7,3.1-4,2.8-4.7h-0.1 c-1.9,0-11.2,6.1-12.5,7.7C305.6,196.8,305.4,199.9,305.4,201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M375.4,139.1c0,0,44.4,42.3,39.2,69.2s-53-15.3-53-15.3l0.7-17.7l19.3,6.6L375.4,139.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.7,188.8c-0.1,0-0.2,0-0.2,0L362.1,176c-0.4-0.1-0.6-0.5-0.5-0.9c0,0,0,0,0,0c0.1-0.4,0.5-0.6,0.9-0.4 l37.4,12.8c0.4,0.1,0.6,0.5,0.5,0.9C400.4,188.6,400.1,188.8,399.7,188.8L399.7,188.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.7,182.6c-0.3,0-0.6-0.3-0.7-0.6l-4-27.2c-0.1-0.4,0.2-0.8,0.6-0.8c0.4-0.1,0.8,0.2,0.8,0.6l0,0l4,27.2 c0.1,0.4-0.2,0.8-0.6,0.8c0,0,0,0,0,0H381.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M355.4,118.1c0.7-7.4,0-13.8-4-20.4c-0.6-1.2-1.5-2.2-2.7-2.9c-1-0.5-1.7-0.2-2.8-0.2 c-0.9,0.1-1.9-0.1-2.7-0.6c-2.2-0.7-4.5-0.8-6.7-0.2c-2.9,0.6-5.6,1.8-8.5,2.2s-6.1,0.2-8.3-1.8c-0.1,2.5,1.2,4.8,3.4,6 c-1.8,0-3.6-0.6-5-1.7c-0.6,2.4-0.1,5,1.5,7c0.2,0.3,0.4,0.5,0.6,0.8c0.2,0.4,0.3,0.9,0.3,1.3c0.1,1.9,0.3,3.8,0.7,5.6 c0.4,1.9,1.5,3.5,3,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M355.4,118.8L355.4,118.8c-0.5,0-0.8-0.4-0.7-0.8c0,0,0,0,0,0c0.8-8.4-0.4-14.2-3.9-20c-0.5-1.1-1.4-2-2.4-2.6 c-0.5-0.3-1.1-0.3-1.7-0.2l-0.7,0.1c-0.8,0.1-1.7-0.1-2.4-0.4l-0.5-0.2c-2-0.7-4.2-0.7-6.3-0.2c-1.3,0.3-2.6,0.7-3.8,1 c-1.5,0.5-3.1,0.9-4.7,1.2c-2.6,0.5-5.2,0.2-7.6-1c0.4,1.6,1.4,3.1,2.9,3.9c0.3,0.2,0.4,0.5,0.4,0.8c-0.1,0.3-0.4,0.5-0.7,0.5l0,0 c-1.6,0-3.1-0.4-4.5-1.2c-0.2,1.9,0.4,3.8,1.5,5.3l0.1,0.1c0.2,0.3,0.4,0.5,0.6,0.8c0.2,0.5,0.3,1.1,0.4,1.6v0.6 c0.1,1.6,0.3,3.3,0.7,4.9c0.4,1.7,1.4,3.2,2.7,4.3c0.3,0.2,0.4,0.7,0.2,1c-0.2,0.3-0.7,0.4-1,0.2c-1.6-1.3-2.8-3.1-3.2-5.1 c-0.4-1.7-0.6-3.4-0.7-5.2v-0.6c0-0.4-0.1-0.7-0.2-1.1c-0.1-0.2-0.2-0.4-0.4-0.6l-0.1-0.2c-1.7-2.1-2.3-5-1.6-7.6 c0.1-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.5,0,0.7,0.1c0.6,0.5,1.4,0.9,2.1,1.1c-1.1-1.4-1.7-3.2-1.6-5c0-0.4,0.3-0.7,0.7-0.7 c0.2,0,0.3,0.1,0.5,0.2c1.7,1.6,4.5,2.2,7.7,1.6c1.5-0.3,3.1-0.7,4.5-1.2c1.3-0.4,2.6-0.8,3.9-1.1c2.3-0.6,4.8-0.5,7.1,0.3l0.6,0.2 c0.5,0.3,1.2,0.4,1.8,0.3c0.2,0,0.4,0,0.6-0.1c0.9-0.2,1.8-0.1,2.5,0.3c1.2,0.8,2.3,1.8,2.9,3.1c3.6,6,4.9,12.3,4.1,20.9 C356.1,118.5,355.8,118.8,355.4,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.9,136.8l1.1,12.7c0,0,2.8,7.9,10.7,4.9c4.7-1.8,8.4-5.7,10-10.5l-2.9-23.1c0,0-6.5-2.5-6.3-15.9 c-6.3,3.7-13.6,5.6-20.9,5.5c0,0-2,14.7-0.2,21C327.2,137.7,333.9,136.8,333.9,136.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.3,155.8c-1.1,0-2.2-0.2-3.3-0.7c-2.2-1.2-3.9-3.1-4.7-5.4c0-0.1,0-0.1,0-0.2l-1-12l0,0 c-1.9,0-7-0.5-8.5-6c-1.8-6.3,0.1-20.7,0.2-21.3c0.1-0.3,0.4-0.6,0.7-0.6h0.3c7.1,0,14.1-1.9,20.3-5.4c0.3-0.2,0.8-0.1,1,0.2 c0.1,0.1,0.1,0.3,0.1,0.4c-0.2,12.7,5.8,15.2,5.8,15.2c0.2,0.1,0.4,0.3,0.5,0.6l2.9,23.1c0,0.1,0,0.2,0,0.3 c-1.6,5.1-5.5,9.1-10.5,11C344.9,155.5,343.6,155.8,342.3,155.8z M335.7,149.3c0.8,1.9,2.2,3.5,4,4.5c1.8,0.8,3.9,0.8,5.8,0 c4.5-1.7,8-5.4,9.5-9.9l-2.8-22.6c-1.4-0.8-6.1-4.2-6.3-15.1c-6,3.2-12.7,4.9-19.6,5c-0.4,2.9-1.7,14.8-0.2,20 c1.6,5.6,7.5,4.9,7.7,4.9c0.2,0,0.4,0,0.5,0.2c0.2,0.1,0.2,0.3,0.3,0.5L335.7,149.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.5,143.4c0,0,3.4,0.2,6.5-3.7s2.6-5.9,2.6-5.9c-2.8,2.1-6.3,3.1-9.8,2.9L334.5,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.6,144.1h-0.2c-0.3,0-0.6-0.3-0.6-0.6l-0.6-6.6c0-0.2,0.1-0.4,0.2-0.6c0.1-0.2,0.3-0.2,0.5-0.2 c3.3,0.2,6.6-0.8,9.3-2.8c0.2-0.1,0.4-0.2,0.6-0.1c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.6,2.4-2.8,6.5 C338.6,143.9,335.4,144.1,334.6,144.1z M334.7,137.5l0.5,5.2c2.2-0.4,4.1-1.6,5.4-3.4c1.1-1.2,1.9-2.6,2.4-4.1 c-2.4,1.5-5.1,2.2-8,2.3L334.7,137.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M334.8,117c0,0-3,7.7-1.6,8.6s4.1-0.5,4.1-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.3,126.6c-0.6,0-1.1-0.1-1.6-0.4c-1.5-1,0-5.7,1.4-9.4c0.1-0.4,0.5-0.5,0.9-0.4c0.4,0.1,0.5,0.5,0.4,0.9 c0,0,0,0,0,0c-1.4,3.6-2.2,7.2-1.9,7.8c0.7,0.5,2.6-0.2,3.4-0.6c0.3-0.2,0.8,0,0.9,0.3c0.2,0.3,0,0.8-0.3,0.9c0,0,0,0,0,0 C336.5,126.2,335.4,126.5,334.3,126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.2,131.2c-2.4-0.1-4.7-1-6.5-2.5c-0.3-0.3-0.3-0.7-0.1-1c0.3-0.3,0.7-0.3,1-0.1c0,0,3.1,2.7,6.6,2.1 c2.1-0.3,3.9-1.8,5.5-4.4c0.2-0.3,0.6-0.5,1-0.3c0,0,0,0,0,0c0.3,0.2,0.5,0.6,0.3,1c0,0,0,0,0,0c-1.7,3-3.9,4.7-6.5,5.1 C336,131.2,335.6,131.3,335.2,131.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    transform: "matrix(0.981 -0.1941 0.1941 0.981 -15.991 67.6219)",
    cx: 337.1,
    cy: 115.4,
    rx: 0.8,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    transform: "matrix(0.981 -0.1941 0.1941 0.981 -16.5299 65.8348)",
    cx: 327.8,
    cy: 117.3,
    rx: 0.8,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.7,120.1c-0.3,0-0.6-0.2-0.7-0.6l-1.3-7.2c0-0.2,0-0.4,0.1-0.5c0.1-0.1,0.3-0.3,0.5-0.3l9.8-1.8 c0.4-0.1,0.7,0.2,0.8,0.6l1.3,7.2c0,0.2,0,0.4-0.1,0.5c-0.1,0.2-0.3,0.3-0.5,0.3l-9.8,1.8L335.7,120.1z M335.1,112.8l1.1,5.8 l8.4-1.6l-1.1-5.8L335.1,112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M323.5,122.4c-0.3,0-0.6-0.2-0.7-0.6l-1.3-7.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.3-0.3,0.5-0.3l9.8-1.8 c0.4-0.1,0.7,0.2,0.8,0.6l1.3,7.2c0,0.2,0,0.4-0.1,0.5c-0.1,0.2-0.3,0.3-0.5,0.3l-9.8,1.8L323.5,122.4z M323,115l1.1,5.8l8.4-1.6 l-1.1-5.8L323,115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.7,115.2L351.7,115.2l-6.7-0.5c-0.4,0-0.7-0.4-0.6-0.8c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0l6.7,0.5 c0.4,0,0.7,0.4,0.7,0.7c0,0,0,0,0,0C352.4,114.9,352.1,115.2,351.7,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347.1,118.1c0.6-1.3,1.4-2.5,2.4-3.6c0.5-0.6,1.2-1,2-1.2c0.6-0.1,1.3,0,1.9,0.3c1.8,0.7,3.1,2.2,3.7,4 c0.3,0.8,0.4,1.7,0.2,2.6c-0.3,1.4-1.1,2.6-2.1,3.4c-1.1,0.8-2.3,1.5-3.5,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M351.7,126.4c-0.3,0-0.5-0.2-0.6-0.4c-0.2-0.3-0.1-0.8,0.3-1c0,0,0,0,0,0c1.2-0.5,2.3-1.2,3.4-2 c1-0.7,1.6-1.8,1.9-3c0.1-0.7,0-1.5-0.2-2.2c-0.6-1.6-1.8-2.9-3.3-3.6c-0.5-0.2-1-0.3-1.5-0.3c-0.6,0.2-1.2,0.5-1.6,1 c-1,1-1.7,2.1-2.2,3.3c-0.2,0.4-0.6,0.5-1,0.4c-0.4-0.2-0.5-0.6-0.4-0.9c0,0,0,0,0,0c0.6-1.4,1.5-2.7,2.5-3.7 c0.6-0.7,1.5-1.2,2.4-1.4c0.8-0.1,1.6,0,2.3,0.3c2,0.8,3.5,2.4,4.1,4.4c0.3,0.9,0.4,2,0.3,2.9c-0.3,1.5-1.2,2.9-2.4,3.8 c-1.1,0.9-2.4,1.6-3.7,2.2C351.9,126.4,351.8,126.4,351.7,126.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266,250.1c-11.4,0-15.6-13.6-19.4-25.6c-2.7-8.5-5.2-16.6-9.7-16.6l0,0c-0.4,0-0.7-0.3-0.7-0.7 c0-0.4,0.3-0.7,0.7-0.7h0.1c5.5,0,8.1,8.1,11,17.5c3.6,11.5,7.7,24.6,18.1,24.6c6.6,0,9.2-17.4,11.5-32.8 c0.9-6.2,1.8-12.2,2.9-16.9c1-4.2,2.4-6.9,4.2-7.8c0.6-0.4,1.4-0.5,2.1-0.3c0.4,0.2,0.5,0.6,0.3,0.9c-0.1,0.3-0.5,0.5-0.8,0.4 c-0.4-0.1-0.8,0-1.1,0.2c-0.8,0.5-2.3,2-3.5,6.9c-1.1,4.6-2,10.5-2.9,16.7C276.4,232.8,273.8,250.1,266,250.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.7,218.3c-15.4,0-35.2-19.4-36.1-20.3c-0.3-0.2-0.4-0.7-0.2-1s0.7-0.4,1-0.2c0.1,0.1,0.1,0.1,0.2,0.2 c0.2,0.2,23.6,23.1,38.5,19.4c0.4-0.1,0.8,0.1,0.9,0.5c0,0,0,0,0,0c0.1,0.4-0.1,0.8-0.5,0.9C405.2,218.2,403.9,218.3,402.7,218.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero1);
export default __webpack_public_path__ + "static/media/Hero-1.9005ce678300ad8ec8d28a616acb427c.svg";
export { ForwardRef as ReactComponent };